import { AwardsApi } from '../clients';
import { mapMembershipsPage } from '../mappers';

export const getCycleMemberships = async (cycleId, filters = {}, page = 1) =>
  mapMembershipsPage(await AwardsApi.getCycleMemberships(cycleId, filters, page));
